<div class="no-results-container">
    <div class="avatar aristocats"></div>
    <h2 class="title">{{ labels?.title }}</h2>
    <p class="copy">{{ labels?.copy }}</p>
    <finder-button class="clear-button" anchor="true" (click)="clearAllFilters()">
        {{ labels.clearButton }}
    </finder-button>
</div>
